import { RecordTypeName } from '../record-type.model';
import {
  Ticket,
  BusinessPurpose,
  TicketGrouping,
  TicketRecordType,
} from './ticket.model';

export function isTicketProactive(ticket: Ticket): boolean {
  return (
    ticket.Business_Purpose__c === BusinessPurpose.NOCProactiveNotification ||
    ticket.Business_Purpose__c === BusinessPurpose.NOCProactiveCarrierAlert ||
    ticket.Business_Purpose__c === BusinessPurpose.NOCProactiveAlert ||
    ticket.Business_Purpose__c === BusinessPurpose.NOCProactiveCustomerAlert ||
    ticket.Business_Purpose__c === BusinessPurpose.NOCProactiveVersaAlert
  );
}

export function isTicketMaintenance(ticket: Ticket): boolean {
  return (
    ticket.Business_Purpose__c === BusinessPurpose.NOCMaintenanceScheduled ||
    ticket.Business_Purpose__c === BusinessPurpose.NOCMaintenanceEmergency ||
    ticket.Business_Purpose__c === BusinessPurpose.NetEngMaintenanceEmergency ||
    ticket.Business_Purpose__c === BusinessPurpose.NetEngMaintenanceStandard
  );
}

export function isTicketSupport(ticket: Ticket): boolean {
  return (
    ticket?.RecordType?.Name === TicketRecordType.NOC &&
    !isTicketProactive(ticket) &&
    !isTicketMaintenance(ticket)
  );
}

export function isNonProactiveTicket(ticket: Ticket): boolean {
  // Check if it's any valid type except Proactive
  return (
    (ticket.RecordType.Name === TicketRecordType.Care ||
      (ticket.RecordType.Name === TicketRecordType.Finance &&
        !ticket.Business_Purpose__c) ||
      isTicketMaintenance(ticket) ||
      isTicketSupport(ticket)) &&
    !isTicketProactive(ticket)
  );
}

export function getTicketType(ticket: Ticket): TicketRecordType[] {
  const types: TicketRecordType[] = [];

  if (
    ticket?.RecordType?.Name === RecordTypeName.Finance &&
    !ticket?.Business_Purpose__c
  ) {
    types.push(TicketRecordType.Finance);
  }
  if (ticket?.RecordType?.Name === RecordTypeName.Care) {
    types.push(TicketRecordType.Care);
  }

  if (isTicketProactive(ticket)) {
    types.push(TicketRecordType.Proactive);
  }
  if (isTicketMaintenance(ticket)) {
    types.push(TicketRecordType.Maintenance);
  }
  if (isTicketSupport(ticket)) {
    types.push(TicketRecordType.Support);
  }

  if (ticket?.Business_Purpose__c === BusinessPurpose.NOCMaintenanceEmergency) {
    types.push(TicketRecordType.Emergency);
  }
  if (isNonProactiveTicket(ticket)) {
    types.push(TicketRecordType.NonProactive);
  }

  return types.length > 0 ? types : [TicketRecordType.Other];
}

/**
 * attempts to map a string value to the type of grouping we doing.
 * If the string value is not one defined, defaults to grouping by Type
 * @param value String value we are mapping to the TicketGrouping Enum
 * @returns The TicketGrouping enum value.
 */
export function mapStringToTicketGrouping(value: string): TicketGrouping {
  if (value.toLocaleLowerCase() === 'type') {
    return TicketGrouping.Type;
  }
  if (value.toLocaleLowerCase() === 'status') {
    return TicketGrouping.Status;
  }
  if (value.toLocaleLowerCase() === 'location') {
    return TicketGrouping.Location;
  }

  // didn't match any type, so just group by type by default
  return TicketGrouping.Type;
}
